// extracted by mini-css-extract-plugin
module.exports = {"h1":"style_h1__2a2Lb","genericButton":"style_genericButton__3UaVT","button":"style_button__1EoIJ","publish":"style_publish__3xxDj"};